import apiClient from "./axiosConfig";

const url = "users/profile/professional";

const updateProfessionalProfile = async (profileData) => await apiClient.patch(`${url}/update/`, profileData)
const updateSingleResource = async (resourceId, resourceType, data) => {
  let body;
  let headers = {};
  const hasFile = Object.values(data).some((v) => v instanceof File);
  if (hasFile) {
    body = new FormData();
    for (let key in data) {
      body.append(key, data[key]);
    }
  } else {
    body = data;
    headers["Content-Type"] = "application/json";
  }

  return await apiClient.patch(
    `${url}/edit/${resourceType}/${resourceId}/`,
    body,
    { headers }
  );
}

const prepareFormData = (data) => {
  let body;
  let headers = {};
  const hasFile = Object.values(data).some((v) => v instanceof File);
  if (hasFile) {
    body = new FormData();
    for (let key in data) {
      if (data[key] !== null && data[key] !== undefined) {
        body.append(key, data[key]);
      }
    }
    // Let axios set the multipart boundary automatically
  } else {
    body = data;
    headers["Content-Type"] = "application/json";
  }
  return { body, headers };
};

const createExperience = async (data) => await apiClient.post(`${url}/add/experience/`, data)

const createLicense = async (data) => {
  const { body, headers } = prepareFormData(data);
  return await apiClient.post(`${url}/add/license/`, body, { headers });
}

const createMedical = async (data) => {
  const { body, headers } = prepareFormData(data);
  return await apiClient.post(`${url}/add/medical/`, body, { headers });
}
const autoExtractCv = async (cv) => await apiClient.post(`${url}/cv/process/`, cv)
const getDocuments = async () => await apiClient.get('/users/documents/list/')
const createDocuments = async (data) => {
  let body;
  let headers = {};
  const hasFile = data.files && data.files.some((v) => v instanceof File);
  if (hasFile) {
    body = new FormData();
    body.append("category", data.category);
    data.files.forEach((file) => {
      body.append("files", file);
    });
  } else {
    body = data;
    headers["Content-Type"] = "application/json";
  }
  return await apiClient.post('/users/documents/upload/add', body, { headers });
};
const deleteDocument = async (id) => await apiClient.delete(`/users/documents/delete/${id}/`)
const deleteLicense = async (id) => await apiClient.delete(`${url}/delete/licenses/${id}/`)
const deleteTabEntry = async (resourceType, resourceId) => await apiClient.delete(`${url}/delete/${resourceType}/${resourceId}/`)

const getVerificationStatus = async () => await apiClient.get(url + '/verification-status/')
const getFieldChoices = async () => await apiClient.get('/users/profile/field-choices/')
const searchProfessionals = async (params) => await apiClient.get(`${url}/search/`, { params })
const getProfessionalDetails = async (id) => await apiClient.get(`${url}/${id}/`)
const downloadProfilePdf = async (id) => await apiClient.get(`${url}/${id}/pdf/`, { responseType: 'blob' })

// Profile Visibility Controls
const getVisibilityRules = async () => await apiClient.get(`${url}/visibility/`)
const upsertVisibilityRule = async (recruiter_id, is_visible) =>
  await apiClient.post(`${url}/visibility/`, { recruiter_id, is_visible })
const deleteVisibilityRule = async (recruiter_id) =>
  await apiClient.delete(`${url}/visibility/${recruiter_id}/`)
const getRecruitersList = async (search = '') =>
  await apiClient.get(`${url}/visibility/recruiters/`, { params: search ? { search } : {} })

export default {
  updateProfessionalProfile,
  updateSingleResource,
  createExperience,
  createLicense,
  createMedical,
  autoExtractCv,
  getDocuments,
  createDocuments,
  deleteDocument,
  getVerificationStatus,
  deleteLicense,
  getFieldChoices,
  deleteTabEntry,
  searchProfessionals,
  getProfessionalDetails,
  downloadProfilePdf,
  // Visibility controls
  getVisibilityRules,
  upsertVisibilityRule,
  deleteVisibilityRule,
  getRecruitersList,
}